import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PhdsoftCommonService, RegionItem } from '@phdsoft/common';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment'
import { RegionsCacheService } from './regions-cache.service';
import { AES, enc } from 'crypto-js'

export interface IRegion {
  id: string,
  name: string
}
@Injectable({
  providedIn: 'root'
})
export class RegionsService {

  constructor(
    private http: HttpClient,
    private phdsoftCommonService: PhdsoftCommonService,
    private regionsCacheService: RegionsCacheService
  ) { }

  post(regions: RegionItem[], assetId: string) {
    return this.http.post(
      environment.API_THREED + `Regions/AddMultiple/${assetId}`, regions
    )
  }

  getFileRegion(url) {
    return this.phdsoftCommonService.getFile(url, false);
  }

  getRegions(assetId: string) {
    let regions$ = this.regionsCacheService.getValue(assetId);

    if (!regions$) {
      regions$ = this.http.get<RegionItem[]>(
        environment.API_THREED + `Regions/GetRegions/${assetId}`).pipe(
          shareReplay(1)
        );
      this.regionsCacheService.setValue(regions$, assetId);
    }

    return regions$;
  }

  getRegion(regionId: string): Observable<RegionItem> {
    return this.http
      .get<RegionItem>(environment.API_THREED + `Regions/${regionId}`)
      .pipe(
        shareReplay(1)
      )
  }

  getRegionsFromBackend(assetId: string) {
    return this.http.get<RegionItem[]>(
      environment.API_THREED + `Regions/GetRegions/${assetId}`);
  }

  getEncryptedRegion(assetId: string, regionId: string) {
    let regions$: any
    if (window.navigator.onLine) {
      // if (!regions$) {
      regions$ = this.http
        .get(
          environment.API_THREED +
          `AssetFiles/GetRegionGltf?assetId=${assetId}&regionId=${regionId}`,
          { responseType: 'arraybuffer' },
        )
        .pipe(
          map((encryptedData: ArrayBuffer) => {
            let encryptedWordArray = enc.Base64.parse(
              btoa(
                new Uint8Array(encryptedData).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  '',
                ),
              ),
            )
            // Decrypt the data
            let key = enc.Base64.parse(environment.DEC_KEY)
            let iv = enc.Base64.parse(environment.DEC_KEYIV)
            let decryptedData = AES.decrypt({ ciphertext: encryptedWordArray }, key, { iv: iv })
            let decryptedBytes = new Uint8Array(decryptedData.sigBytes)
            for (let i = 0; i < decryptedData.sigBytes; i++) {
              decryptedBytes[i] = (decryptedData.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 255
            }

            let blob = new Blob([decryptedBytes], { type: 'model/gltf-binary' })
            return decryptedBytes.buffer
          }),
          shareReplay(1),
        )
    } else {
      regions$ = this.regionsCacheService.getValue(assetId)
    }
    return regions$
  }

  clearCache() {
    this.regionsCacheService.clearCache()
  }
}
